import { useDataBoxSelector } from 'app/common/data-box-store'
import { AcquiringSettings } from 'app/dataTypes/acquiring/settings'

import { acquiringSettings } from '../dataBox'

export function useAcquiringSettingsData() {
  const data = useDataBoxSelector<AcquiringSettings>(
    acquiringSettings,
    () => acquiringSettings.data,
  )
  return data
}
